if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        this.submitButton = this.querySelector('[type="submit"]');
        if (this.submitButton === null) return
        this.submitButtonText = this.submitButton.querySelector('span');


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
      
        const clickedButton = evt.submitter;
        const actionType = clickedButton?.dataset?.action || 'add';
      
        if (clickedButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();
        clickedButton.setAttribute('aria-disabled', true);
        clickedButton.classList.add('loading');
      
        const spinner = clickedButton.querySelector('.loading-spinner');
        const buttonText = clickedButton.querySelector('span');
        if (spinner) spinner.classList.remove('hidden');
        if (buttonText) buttonText.classList.add('hidden');
      
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
        const formData = new FormData(this.form);
      
        if (actionType === 'sample') {
          const sampleId = document.querySelector('.product_sample_id')?.value;
          const sampleProductId = document.querySelector('.product_sample_product_id')?.value;
          formData.set('id', sampleId);
          formData.set('product-id', sampleProductId);
        }
      
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
      
        config.body = formData;
      
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              clickedButton.setAttribute('aria-disabled', true);
              return;
            }
      
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
      
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            clickedButton.classList.remove('loading');
            clickedButton.removeAttribute('aria-disabled');
      
            if (spinner) spinner.classList.add('hidden');
            if (buttonText) buttonText.classList.remove('hidden');
      
            if (this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
          });
      }
      
      

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (this.submitButton === null) return
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
